import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { BookingModal } from 'components/BookingModal/BookingModal';

export const OpenBookingModalButton = (props) => {
  const {
    tessituraId,
    performanceId,
    eventDateValue,
    sitecoreItemId,
    classes,
    buttonText = 'Book Now',
  } = props;
  const [openModal, setOpenModal] = useState(false);
  const [promoCodeFromUrl, setPromoCodeFromUrl] = useState(false);

  /*
   * Check window url for existence of 'emailsource'
   * and open the modal if it exists.
   */
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlPromocodeParam = urlParams.get('emailsource');
    const findSeatsParam = urlParams.get('findtickets');

    const openModalTimer = setTimeout(() => {
      const bookingModalNotOpen = document.querySelectorAll('div.booking-modal').length === 0;

      if (bookingModalNotOpen) {
        if (urlPromocodeParam) {
          setPromoCodeFromUrl(urlPromocodeParam);
          setOpenModal(true);
        }

        if (findSeatsParam) {
          setOpenModal(true);
        }
      }
    }, 500);

    return () => {
      clearTimeout(openModalTimer);
    };
  }, []);

  const openModalHandler = () => setOpenModal(true);
  const closeModalHandler = () => setOpenModal(false);

  const eventMetaData = {
    prodSeasonId: tessituraId,
    performanceId,
    performanceDate: eventDateValue,
    sitecoreItemId,
  };

  return (
    <>
      <a className={classes} onClick={openModalHandler}>
        {buttonText}
      </a>
      {openModal && (
        <BookingModal
          modalIsOpen={openModal}
          promoCodeFromUrl={promoCodeFromUrl}
          closeModalHandler={closeModalHandler}
          {...eventMetaData}
        />
      )}
    </>
  );
};

export const OpenBookingModalButtonSC = (props) => {
  const { sitecoreData } = props;
  return <OpenBookingModalButton {...sitecoreData} />;
};

OpenBookingModalButtonSC.propTypes = {
  sitecoreData: PropTypes.object,
};

OpenBookingModalButton.propTypes = {
  tessituraId: PropTypes.string,
  performanceId: PropTypes.string,
  eventDateValue: PropTypes.string,
  sitecoreItemId: PropTypes.string,
  classes: PropTypes.string,
  buttonText: PropTypes.string,
};
